import styled from 'styled-components';

export const Container = styled.div`
  display: inline-block;
  position: relative;
`;

export const Icon = styled.div`
  cursor: pointer;

  &:hover ~ div {
    display: block;
  }
`;
